import { getFullMetadataElementId } from '../../metadata-elements/metadataElementUtils';

export const isMetadataElementInCanvas = ({
  metadataId,
  crmOrgId,
  canvasFunnelMap,
}: {
  metadataId: string;
  crmOrgId: string;
  canvasFunnelMap: FunnelMap;
}) => {
  const id = getFullMetadataElementId({ crmOrgId, metadataId });
  return !!canvasFunnelMap?.metadataElementsData?.[id];
};
